module.exports = __webpack_public_path__ + "media/base/teammember_small-2c585bc6.svg";